import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { Button } from '@mui/material';
import LoadingBlock from 'components/shared/blocks/LoadingBlock';
import LargeSessionCard from 'components/shared/cards/session/LargeSessionCard';
import { roles } from 'common/constants/options';
import StyledSessionSideList from 'common/theme/session/side-list/StyledSessionSideList';
import StyledSessionSideListContainer from 'common/theme/session/side-list/StyledSessionSideListContainer';
import StyledSessionSideListHeader from 'common/theme/session/side-list/StyledSessionSideListHeader';
import StyledSessionSideListHeaderTitle from 'common/theme/session/side-list/StyledSessionSideListHeaderTitle';

function SessionsSideList({
  disableReset = true,
  onReset = null,
  sessions,
  status,
  viewType = roles.administrator
}) {
  const { t } = useTranslation(['buttons', 'routes', 'sessions']);
  const hasSessions = sessions.length > 0;

  return (
    <StyledSessionSideListContainer hasSessions={hasSessions}>
      <StyledSessionSideListHeader>
        <StyledSessionSideListHeaderTitle>
          {t('session.list', { ns: 'routes' })}
        </StyledSessionSideListHeaderTitle>
        <Button
          variant="text"
          color="inherit"
          sx={{ color: 'text.primary' }}
          disabled={disableReset}
          disableElevation
          onClick={onReset}>
          {t('reset', { ns: 'buttons' })}
        </Button>
      </StyledSessionSideListHeader>
      <LoadingBlock
        emptyBlockProps={{
          imageType: 'calendar',
          imageWidth: '150px',
          message: t('noSessions', { ns: 'sessions' })
        }}
        isValid={hasSessions}
        skeletonProps={{ height: 150, rows: 3 }}
        status={status}
        type="table">
        <StyledSessionSideList spacing={2}>
          {sessions.map((session) => (
            <LargeSessionCard data={session} userRole={viewType} key={session.id} />
          ))}
        </StyledSessionSideList>
      </LoadingBlock>
    </StyledSessionSideListContainer>
  );
}

SessionsSideList.propTypes = {
  disableReset: PropTypes.bool,
  onReset: PropTypes.func,
  sessions: PropTypes.array.isRequired,
  status: PropTypes.string.isRequired,
  viewType: PropTypes.string
};

export default SessionsSideList;
